<template>
    <div class="row mb-5 align-items-center">
        <div class="col-12">
            <b-alert v-if="message" variant="danger" show>{{message}}</b-alert>
            <ValidationObserver ref="creditPriceForm" v-if="!message && !formLoading">
                <div class="row">
                    <div class="col-12">
                        <ValidationProvider name="fall_credit" rules="" v-slot="{ valid, errors }">
                            <b-form-group>
                                <label class="col-form-label pt-0">{{ $t('fall_credit') }}</label>
                                <b-form-input type="number" step="1"
                                              v-model="creditPriceForm.fall_credit"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="spring_credit" rules="" v-slot="{ valid, errors }">
                            <b-form-group>
                                <label class="col-form-label pt-0">{{ $t('spring_credit') }}</label>
                                <b-form-input type="number" step="1"
                                              v-model="creditPriceForm.spring_credit"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>

                    <div class="col-12">
                        <b-button type="submit" @click="saveCredits" variant="primary">{{
                                $t('save')
                            }}
                        </b-button>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
//Component
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import PaymentPlanService from "@/services/PaymentPlanService";
import StudentProgramService from "@/services/StudentProgramService";
//Service

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        ProgramSelectbox,
        FacultySelectbox,
        StatusSelectbox,
        AcademicYearsSelectbox

    },
    props: {
        studentProgramId: {
            default: null
        },
        allowLoad: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formLoading: false,
            creditPriceForm: {
                fall_credit: null,
                spring_credit: null,
            },
            message: null
        }
    },
    methods: {
        async saveCredits() {
            if (!this.creditPriceForm.fall_credit && !this.creditPriceForm.spring_credit) {
                this.$toast.error(this.$t('fill_at_least_one_field'));
            }

            const isValid = await this.$refs.creditPriceForm.validate();
            if(!isValid){
                return;
            }

            this.creditPriceForm.student_program_id = this.studentProgramId;
            PaymentPlanService.credit(this.creditPriceForm).then(response => {
                this.toast(response.data);
                this.$emit('creditFormSaved');
            })
                .catch(e => {
                    this.showErrors(e, this.$refs.creditPriceForm);
                });
        },
        getCredits() {
            this.formLoading=true;
            this.message = null;
            StudentProgramService.getCredits(this.studentProgramId).then((response) => {
                this.creditPriceForm = response.data.data;
            }).catch(e=>{
                this.message = this.getErrorMessage(e.data);
            }).finally(() => {
                this.formLoading = false;
            });
        }
    },
    watch: {
        allowLoad: function (newVal, oldVal) {
            if (newVal && this.studentProgramId) {
                this.getCredits();
            }
        }
    },
    created() {
    }
}
</script>
